module.exports = __webpack_public_path__ + "static/energy_3-a3f30bd223ca0111ba267b6632da145f.jpg";